<template>
<div class="div-oftaHistory">
  <br>
  <Title2
    title="HISTORIAL GENERAL DEL PACIENTE"
    label="Datos generales del paciente"
  />
  <h3>{{this.idApointment}}</h3>
  <history/>
</div>
</template>

<script>
import history from '../../components/HistorySocialComponent';
import Title2 from '../../components/Title2';

export default {
  props: {
    idApointment: String,
  },
  data() {
    return {
      data: [],
    };
  },
  components: {
    history,
    Title2,
  },
  methods: {
  },
  async mounted() {
    this.getData();
  },
};
</script>

<style scoped>
.div-oftaHistory{
  min-height: auto;
  margin: auto;
  background-color: #fff;
}
</style>
